import React from 'react'

function Footer() {
  return (
    <div className='p-4 bg-black text-white text-center mt-96 mb-1'>
      <h1>© Copyrights | All rights reserved</h1>
    </div>
  )
}

export default Footer
